import { Permission, hasPermission, UserAttributes } from "../../models/auth";

/**
 * Get the first available route based on user permissions
 * Returns the path to redirect to based on what the user has access to
 */
export const getFirstAvailableRoute = (userAttributes: UserAttributes): string => {
  // Define routes in order of priority
  const routePermissions = [
    { path: "/patients", permission: Permission.PATIENT },
    { path: "/documents", permission: Permission.DOCUMENT },
    { path: "/cohorts", permission: Permission.COHORT },
    { path: "/studies", permission: Permission.PROJECT },
    { path: "/rpm/inclusion", permission: Permission.RPM },
  ];

  // Find the first route the user has permission to access
  for (const route of routePermissions) {
    if (hasPermission(userAttributes, route.permission)) {
      return route.path;
    }
  }

  // Check admin route only for on-premise installations
  if (window.CONFIG.auth.kind === "SIMPLE" && hasPermission(userAttributes, Permission.ADMIN)) {
    return "/admin";
  }

  // Fallback to user profile if no other permissions
  return "/user/profile";
};
